import { render, staticRenderFns } from "./logisinvoice.vue?vue&type=template&id=60b3c49f&scoped=true"
import script from "./logisinvoice.vue?vue&type=script&lang=js"
export * from "./logisinvoice.vue?vue&type=script&lang=js"
import style0 from "./logisinvoice.vue?vue&type=style&index=0&id=60b3c49f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b3c49f",
  null
  
)

export default component.exports